import React, { useState } from "react";
import { FaPhone, FaEnvelope, FaMapMarkerAlt } from "react-icons/fa";
import emailjs from "@emailjs/browser";


import "../styles/contact.css"; // Make sure to create this CSS file

const ContactUs = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    address: "",  // Added missing field
    message: "",
  });

  const [errors, setErrors] = useState({});
  const [success, setSuccess] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const validateForm = () => {
    let newErrors = {};
    if (!formData.name.trim()) newErrors.name = "Name is required!";
    if (!formData.email.trim()) newErrors.email = "Email is required!";
    else if (!/\S+@\S+\.\S+/.test(formData.email)) newErrors.email = "Invalid email format!";
    if (!formData.address.trim()) newErrors.address = "Address is required!"; // Added address validation
    if (!formData.message.trim()) newErrors.message = "Message cannot be empty!";
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

const handleSubmit = (e) => {
  e.preventDefault();
  if (validateForm()) {
    emailjs.send(
      'service_pqbc59h',       
      'template_x6j4izh',      
      formData,
      'ChGaPDB97O33PHhHU'    
    )
    .then((response) => {
      console.log('SUCCESS!', response.status, response.text);
      setSuccess(true);
      setFormData({ name: "", email: "", address: "", message: "" });
      setTimeout(() => setSuccess(false), 3000);
    })
    .catch((err) => {
      console.error('FAILED...', err);
    });
  }
};


  return (
    <div className="container mt-5 contact-container">
      <h2 className="text-center text-primary">Get in Touch</h2>
      <p className="text-center text-muted">We’d love to hear from you! Contact us today.</p>

      <div className="row mt-4">
        {/* Contact Info Section */}
        <div className="col-lg-5 mb-4">
          <div className="contact-info p-4 shadow rounded">
            <h4>Contact Information</h4>
            <p>
              <FaMapMarkerAlt className="icon location-icon" /> Saheed Bhagat Singh Apartment <br />
              Flat No.534 First Floor, 
              Phase-2, Sector-14,<br /> New Delhi-110075, India
            </p>
            <p><FaPhone className="icon" /> +91 9586314428</p>
            <p><FaEnvelope className="icon" /> mediasha865@gmail.com</p>
          </div>
        </div>

        {/* Contact Form Section */}
        <div className="col-lg-7">
          <div className="card p-4 shadow">
            <form onSubmit={handleSubmit}>
              <div className="mb-3">
                <label className="form-label">Full Name</label>
                <input 
                  type="text" name="name" className="form-control"
                  value={formData.name} onChange={handleChange} 
                />
                {errors.name && <span className="text-danger">{errors.name}</span>}
              </div>

              <div className="mb-3">
                <label className="form-label">Email ID</label>
                <input 
                  type="email" name="email" className="form-control"
                  value={formData.email} onChange={handleChange} 
                />
                {errors.email && <span className="text-danger">{errors.email}</span>}
              </div>

              <div className="mb-3">
                <label className="form-label">Address</label>
                <textarea 
                  name="address" className="form-control" rows="2"
                  value={formData.address} onChange={handleChange} 
                ></textarea>
                {errors.address && <span className="text-danger">{errors.address}</span>}
              </div>

              <div className="mb-3">
                <label className="form-label">Comments/Request</label>
                <textarea 
                  name="message" className="form-control" rows="3"
                  value={formData.message} onChange={handleChange} 
                ></textarea>
                {errors.message && <span className="text-danger">{errors.message}</span>}
              </div>

              <button type="submit" className="btn btn-primary w-100">Send Message</button>

              {success && <p className="text-success mt-3">Message sent successfully!</p>}
            </form>
          </div>
        </div>
      </div>

      {/* Embedded Google Map */}
      <div className="map-container mt-4">
        <iframe
          title="Google Map"
          className="w-100 rounded shadow"
          height="350"
          src="https://www.google.com/maps/embed/v1/place?q=Shaheed+Bhagat+Singh+Apartment&key=AIzaSyBFw0Qbyq9zTFTd-tUY6dZWTgaQzuU17R8"
          allowFullScreen
        ></iframe>
      </div>
    </div>
  );
};

export default ContactUs;